<template>
  <div>
    <div class="barcode-designer" id="non-printable">
      <!-- Toolbar -->
      <v-toolbar flat fixed class="designer-toolbar">
        <!-- <v-toolbar-side-icon @click="fn_goBack">
          <v-icon>arrow_back</v-icon>
        </v-toolbar-side-icon> -->
        <v-toolbar-side-icon @click="fieldDrawer=true">
          <v-icon>list</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title class="white--text">{{ $t('barcode.designer.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fn_labelPerview" :title="$t('barcode.designer.previewLabel')">
          <img src="../../assets/icon_preview.svg" alt="preview_icon"></img>
        </v-btn>

        <!-- <v-btn color="success" to="/settings/usbdevices">text</v-btn> -->
        <!-- <v-btn icon @click="fn_openSheet" :title="$t('barcode.designer.sheetLayout')"><v-icon>grid_on</v-icon></v-btn> -->
        <!-- <v-btn icon @click="isCustom=!isCustom"><v-icon>settings</v-icon></v-btn> -->
        <!-- <v-btn icon @click="fn_saveTemplate" color="white">
          <v-icon>save</v-icon>
        </v-btn> -->
      </v-toolbar>

      <!-- Main Container -->
      <div class="designer-container hasToolbar hasFooter white-background" style="overflow: auto;">
        <!-- Left Panel - Settings -->
        <div class="left-panel" v-if="isCustom">
          <v-card flat class="settings-card">
            <v-card-title class="pb-2">
              <v-icon left>settings</v-icon>Label Settings
            </v-card-title>
            
            <v-divider></v-divider>
            
            <v-card-text>
              <!-- Label Dimensions -->
              <div class="settings-section">
                <v-subheader>{{ $t('barcode.designer.labelDimensions') }}</v-subheader>
                <v-select
                  v-model="labelName"
                  :items="labelDimensions"
                  item-text="label"
                  item-value="id"
                  @change="fn_changeDimension"
                  outlined
                  dense
                ></v-select>
                <div class="dimension-display mt-2">
                  <span>{{ currentDimension.width }}mm × {{ currentDimension.height }}mm</span>
                </div>
              </div>

              <v-divider class="my-3"></v-divider>

              <!-- Ruler Unit -->
              <div class="settings-section">
                <v-subheader>{{ $t('barcode.designer.rulerUnit') }}</v-subheader>
                <!-- <v-btn-group full-width> -->
                  <v-btn
                    @click="rulerUnit = 'mm'"
                    :color="rulerUnit === 'mm' ? 'primary' : ''"
                    small
                  >
                    MM
                  </v-btn>
                  <v-btn
                    @click="rulerUnit = 'cm'"
                    :color="rulerUnit === 'cm' ? 'primary' : ''"
                    small
                  >
                    CM
                  </v-btn>
                <!-- </v-btn-group> -->
              </div>

              <v-divider class="my-3"></v-divider>

              <!-- Add Field Button -->
              <div class="settings-section">
                <v-btn
                  @click="fn_openFieldSelector"
                  color="primary"
                  block
                  outlined
                >
                  <v-icon left>add</v-icon>{{ $t('barcode.designer.addField') }}
                </v-btn>
              </div>

              <v-divider class="my-3"></v-divider>

              <!-- Selected Field Properties -->
              <div v-if="selectedFieldLive" class="settings-section">
                <v-subheader>{{ $t('barcode.designer.fieldProperties') }}</v-subheader>
                <div class="field-props">
                  <p><strong>{{ $t('barcode.designer.field') }}:</strong> {{ selectedFieldLive.fieldName }}</p>
                  <p><strong>{{ $t('barcode.designer.position') }}:</strong> X: {{ selectedFieldLive.posLeft }}mm, Y: {{ selectedFieldLive.posTop }}mm</p>
                  <p><strong>{{ $t('barcode.designer.size') }}:</strong> W: {{ selectedFieldLive.width }}mm, H: {{ selectedFieldLive.height }}mm</p>
                </div>
                <v-btn
                  @click="fn_editField"
                  color="info"
                  small
                  block
                  class="mt-2 mb-2"
                >
                  Edit
                </v-btn>
                <v-btn
                  @click="fn_removeField"
                  color="error"
                  small
                  block
                >
                  Remove
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div>

        <!-- Label setup: name, then Width and Height each as a preset dropdown
             with a paired input that enables only when "Custom" is chosen. -->
        <div class="label-setup pl-3 pr-3 mb-2">

          <!-- <v-subheader nopadding>{{ $t('barcode.designer.printerType') }} <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn nopadding nomargin capitalize color="primary" flat slot="activator">{{ printerType }} <v-icon color="primary">arrow_drop_down</v-icon></v-btn>
              <v-list dense>
                <v-list-tile @click="printerType = 'Label Printer'">
                  <v-list-tile-title>{{ $t('barcode.designer.labelPrinter') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="printerType = 'Regular Printer'">
                  <v-list-tile-title>{{ $t('barcode.designer.regularPrinter') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-subheader> -->

          <v-layout row wrap pt-3>
            <!-- <v-flex xs12 sm12 md12 mb-3>
                <v-radio-group v-model="printerType" row hide-details>
                  <v-radio :label="$t('barcode.designer.labelPrinter')" value="Label"></v-radio>
                  <v-radio :label="$t('barcode.designer.regularPrinter')" value="Regular"></v-radio>
                </v-radio-group>
              </v-flex> -->

              <v-flex xs12 sm12 md12 mb-3>
                <v-text-field
                  :label="$t('barcode.designer.labelName')"
                  v-model="labelName"
                  placeholder=" "
                  outlined dense hide-details
                ></v-text-field>
              </v-flex>
          </v-layout>

          <v-expansion-panel nomargin v-model="configPanel">
            <v-expansion-panel-content style="background-color: inherit;">
              <v-subheader slot="header" nopadding>{{ $t('barcode.designer.labelSettings') }}</v-subheader>
              <v-divider style="border-color:rgba(0,0,0,0.4);"></v-divider>
              <template>
                  <!-- Width -->
                  <v-layout row wrap mt-3>

                    <!-- <v-flex xs12 sm12 md12 mb-3>
                      <v-select
                        v-model="printType"
                        placeholder=" "
                        :label="$t('barcode.designer.printType')"
                        :items="['Label', 'Regular']"
                        outlined dense hide-details
                      ></v-select>
                    </v-flex> -->

                    <v-flex xs6 pr-2 mb-3>
                      <v-select
                        v-model="widthSelection"
                        :label="$t('barcode.designer.labelWidth')"
                        :items="widthItems"
                        @change="fn_onWidthChange"
                        outlined dense hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 pl-2>
                      <v-text-field
                        :label="$t('barcode.designer.widthMm')"
                        type="number" min="5"
                        v-model.number="labelWidth"
                        :disabled="widthSelection !== 'custom'"
                        @input="fn_onCustomDim"
                        outlined dense hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <!-- Height -->
                  <v-layout row wrap class="mt-2">
                    <v-flex xs6 pr-2 mb-3>
                      <v-select
                        v-model="heightSelection"
                        :label="$t('barcode.designer.labelHeight')"
                        :items="heightItems"
                        @change="fn_onHeightChange"
                        outlined dense hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 pl-2>
                      <v-text-field
                        :label="$t('barcode.designer.heightMm')"
                        type="number" min="5"
                        v-model.number="labelHeight"
                        :disabled="heightSelection !== 'custom'"
                        @input="fn_onCustomDim"
                        outlined dense hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <!-- N-up media: stickers side by side on the roll (label-printer). -->
                  <v-layout row wrap class="mt-3">
                    <v-flex xs12 sm12 md12 mb-3>
                      <!-- <v-select
                        v-model.number="media.columns"
                        :label="$t('barcode.designer.columns')"
                        :items="[1, 2]"
                        outlined dense hide-details
                      ></v-select> -->

                      <!-- <div light-opacity-color>{{ $t('barcode.designer.columns') }}</div> -->
                      <v-chip small>{{ $t('barcode.designer.columns') }}</v-chip>
                      <v-radio-group v-model="media.columns" row hide-details @change="fn_hideGaps" class="mt-2">
                        <v-radio :label="$t('barcode.designer.oneLabel')" :value="1"></v-radio>
                        <v-radio :label="$t('barcode.designer.twoLabels')" :value="2"></v-radio>
                      </v-radio-group>

                    </v-flex>
                    <v-flex xs6 sm6 md6 pr-2 mb-3 v-if="media.columns > 1">
                      <v-text-field
                        :label="$t('barcode.designer.gapX')"
                        type="number" min="0" step="0.5"
                        v-model.number="media.gapXMm"
                        :disabled="media.columns < 2"
                        outlined dense hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6 pl-2 mb-3 v-if="media.columns > 1">
                      <v-text-field
                        :label="$t('barcode.designer.gapY')"
                        type="number" min="0" step="0.5"
                        v-model.number="media.gapYMm"
                        outlined dense hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-divider style="border-color:rgba(0,0,0,0.4);" v-if="configPanel != 0"></v-divider>

          <v-layout row wrap>
            <!-- <v-flex xs6 sm6 md6>
              <div class="setup-summary">
                <v-checkbox :label="$t('barcode.designer.hideConfigs')" class="mt-2" v-model="hideConfigs"></v-checkbox>
              </div>
            </v-flex> -->

            <v-flex xs12 sm12 md12>
              <div class="setup-summary right-align pt-3">
                {{ labelWidth }} * {{ labelHeight }} mm
              </div>
            </v-flex>

          </v-layout>
        </div>

        <!-- Label name/paper/size now live in the .label-setup card below. -->
        <!-- <div class="settings-section pl-3 pr-3">
          <v-switch :label="$t('barcode.designer.showFieldLabels')" v-model="showFieldLabels"></v-switch>
        </div> -->

        <!-- Center Panel - Designer Canvas -->
        <div class="center-panel" data-no-translate>
          <div class="canvas-wrapper">
            <!-- Ruler Container -->
            <div class="ruler-container">
              <!-- Top-Left Corner -->
              <div class="ruler-corner"></div>

              <!-- Top Ruler (X-Axis) -->
              <div class="ruler ruler-x" :style="{ width: rulerWidth + 'px' }">
                <div
                  v-for="(mark, idx) in xAxisMarks"
                  :key="'x-' + idx"
                  class="ruler-mark"
                  :style="{ left: mark.pos + 'px' }"
                >
                  <div class="ruler-tick" :class="{ 'ruler-tick-major': mark.isLabel, 'ruler-tick-mid': mark.isMid }"></div>
                  <div v-if="mark.isLabel" class="ruler-label">{{ mark.label }}</div>
                </div>
              </div>
            </div>

            <div style="display: flex;">
              <!-- Left Ruler (Y-Axis) -->
              <div class="ruler ruler-y" :style="{ height: rulerHeight + 'px' }">
                <div
                  v-for="(mark, idx) in yAxisMarks"
                  :key="'y-' + idx"
                  class="ruler-mark"
                  :style="{ top: mark.pos + 'px' }"
                >
                  <div class="ruler-tick" :class="{ 'ruler-tick-major': mark.isLabel, 'ruler-tick-mid': mark.isMid }"></div>
                  <div v-if="mark.isLabel" class="ruler-label">{{ mark.label }}</div>
                </div>
              </div>

              <!-- Canvas -->
              <div
                class="designer-canvas"
                :style="canvasStyle"
                @click="fn_deselectField"
              >
                <!-- Alignment Guides -->
                <div id="guideX" class="guide guide-x"></div>
                <div id="guideY" class="guide guide-y"></div>

                <!-- Fields -->
                <template v-for="(field, index) in fields">
                  <div
                    :key="'field-' + index"
                    :id="'field-' + index"
                    class="designer-field"
                    :class="{
                      'field-selected': selectedFieldId === index,
                      'field-collision': hasCollision(index)
                    }"
                    :style="getFieldStyle(field, index)"
                    @click.stop="fn_selectField(index)"
                    @pointerdown="fn_startDrag"
                    @touchstart="fn_startDrag"
                  >
                    <div v-if="field.fieldName === 'Image' && field.imageData" class="field-content canvas-image">
                      <img :src="field.imageData" style="width: 100%; height: 100%; object-fit: contain;">
                    </div>
                    <div v-else class="field-content">
                      <span>{{ fn_canvasText(field) }}</span>
                    </div>
                  </div>

                  <!-- Design-only name tag for the selected field. A canvas
                       sibling (not a child of the field box, which clips with
                       overflow:hidden). Floats above the field, or below it near
                       the top edge. Never rendered on preview/thermal/sheet. -->
                  <div
                    v-if="selectedFieldId === index || showFieldLabels"
                    :key="'badge-' + index"
                    class="field-badge"
                    :class="{ 'field-badge-below': fn_mmToPx(field.posTop) < 18 }"
                    :style="fn_badgeStyle(field)"
                  >{{ field.fieldName }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <v-layout row wrap mt-3 style="flex:none"> 
          <v-flex xs6 sm6 md6 pl-3 pr-1>
            <v-btn color="primary" block outline @click="fn_editField" :disabled="!selectedFieldData"><v-icon color="primary" font20 class="mr-2">edit</v-icon> {{ $t('barcode.designer.changeStyle') }}</v-btn>
            <div class="caption grey--text">{{ $t('barcode.designer.selectFieldToStyle') }}</div>
          </v-flex>

          <v-flex xs6 sm6 md6 pr-3 pl-1>
            <v-btn color="primary" block outline @click="fn_openFieldSelector"><v-icon color="primary" font20 class="mr-2">add</v-icon> {{ $t('barcode.designer.addField') }}</v-btn>
          </v-flex>
        </v-layout>

        

        <!-- Right Panel - Field List -->
        <!-- <div class="right-panel">
          <v-card flat class="fields-list-card">
            <v-card-title class="pb-2">
              <v-icon left>list</v-icon>Fields
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="fields-list-content">
              <div v-if="fields.length === 0" class="no-fields">
                <p>{{ $t('barcode.designer.noFieldsAdded') }}</p>
              </div>
              <div
                v-for="(field, index) in fields"
                :key="'list-' + index"
                class="field-item"
                :class="{ 'field-item-selected': selectedFieldId === index }"
                @click="fn_selectField(index)"
              >
                <div class="field-item-content">
                  <strong>{{ field.fieldName }}</strong>
                  <small v-if="field.fieldValue" class="field-item-value">
                    {{ field.fieldValue }}
                  </small>
                </div>
                <v-btn
                  icon
                  small
                  @click.stop="fn_removeField(index)"
                >
                  <v-icon small>close</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div> -->

         <!-- <v-btn block style="height: 48px;" noshadow color="primary" @click="fn_getTemplate">get</v-btn> -->

         <!-- <v-btn block style="height: 48px;" noshadow color="primary" @click="fn_getTemplates">get templates</v-btn> -->

        <v-footer style="position: fixed; bottom: 0; left: 0; right: 0; background-color: #fff; border-top: 1px solid #ddd;height: 48px;">
          <v-layout row wrap center-align>
              <v-flex xs6 sm6 md6>
                  <v-btn color="primary" style="height: 48px;" block flat @click="fn_cancel">{{ $t('barcode.designer.cancel') }}</v-btn>
              </v-flex>
              <v-flex xs6 sm6 md6>
                  <v-btn block style="height: 48px;" noshadow color="primary" @click="fn_saveTemplate">{{ $t('barcode.designer.save') }}</v-btn>
              </v-flex>
          </v-layout>
      </v-footer>
      </div>

      <!-- Field Selector Dialog -->
      <v-dialog
        v-model="showFieldSelector"
        scrollable
        max-width="400px"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-card-title class="pb-2 pt-2">
            <span>{{ $t('barcode.designer.selectFieldToAdd') }}</span>
            <v-spacer></v-spacer>
            <v-btn icon class="pa-0 ma-0" @click="showFieldSelector = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text nopadding data-no-translate>
            <v-list>
              <v-list-tile
                v-for="fieldName in availableFields"
                :key="fieldName"
                @click="fn_addField(fieldName)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ fieldName }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>add_circle_outline</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Add-time label dialog for Date / Input Text prompt fields -->
      <v-dialog v-model="showPromptDialog" max-width="420px" persistent transition="dialog-bottom-transition">
        <v-card flat>
          <v-card-title noshadow class="pb-2">
            <span>{{ $t('barcode.designer.addPromptTitle', { name: promptDraft.fieldName }) }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p class="grey--text mb-2" style="font-size:13px;">
              {{ $t('barcode.designer.promptHelp') }}
            </p>
            <v-text-field
              v-model="promptDraft.label"
              :label="$t('barcode.designer.fieldLabelInput')"
              :placeholder="promptDraft.inputType === 'date' ? $t('barcode.designer.hintExpiryDate') : $t('barcode.designer.hintWarranty')"
              :error-messages="promptError"
              autofocus
              outlined dense
              @keyup.enter="fn_confirmPromptField"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showPromptDialog = false">{{ $t('barcode.designer.cancel') }}</v-btn>
            <v-btn flat color="primary" @click="fn_confirmPromptField">{{ $t('barcode.designer.add') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Field Edit Dialog -->
      <v-dialog
        v-model="showFieldEditor"
        max-width="400px"
        transition="dialog-bottom-transition"
        scrollable
        persistent  
      >
        <v-card v-if="selectedFieldData">
          <v-card-title class="pt-2 pb-2" noshadow>{{ $t('barcode.designer.editField') }} <v-spacer></v-spacer> <v-btn icon small @click="fn_removeField(selectedFieldId, 1)" class="ma-0 pa-0"><v-icon class="redcolor font20">delete</v-icon></v-btn></v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              v-if="selectedFieldData && selectedFieldData.fieldName !== 'Image' && !fn_isPromptField(selectedFieldData)"
              v-model="selectedFieldData.fieldValue"
              :disabled="selectedFieldData.fieldName === 'Barcode'"
              :label="$t('barcode.designer.fieldValue')"
              outlined
              dense
            ></v-text-field>

            <v-checkbox :label="$t('barcode.designer.showRateLabel')" v-model="selectedFieldData.rateLabel" v-if="selectedFieldData.fieldName === 'Rate'"></v-checkbox>
            <v-checkbox :label="$t('barcode.designer.showMrpLabel')" v-model="selectedFieldData.mrpLabel" v-if="selectedFieldData.fieldName === 'MRP'"></v-checkbox>

            <!-- Prompt field (Date / Input Text): value is asked for at
                 generation, so here we only configure how it reads. -->
            <div v-if="fn_isPromptField(selectedFieldData)">
              <div style="padding: 8px 12px; background-color: #f0f7ff; border-left: 3px solid #2196f3; border-radius: 4px;" class="mb-3">
                <small style="color: #1976d2;">
                  <strong>{{ selectedFieldData.promptLabel }}</strong>
                  — {{ selectedFieldData.inputType === 'date' ? $t('barcode.designer.promptValueDate') : $t('barcode.designer.promptValueText') }} {{ $t('barcode.designer.promptEnteredAt') }}.
                </small>
              </div>
              <v-checkbox
                v-model="selectedFieldData.showCaption"
                :label="$t('barcode.designer.printCaption')"
                hide-details
                class="mt-0 mb-1"
              ></v-checkbox>
              <v-text-field
                v-if="selectedFieldData.showCaption"
                v-model="selectedFieldData.captionText"
                :label="$t('barcode.designer.captionText')"
                :hint="$t('barcode.designer.captionHint')"
                persistent-hint
                outlined dense
                class="mb-2"
              ></v-text-field>
            </div>

            <!-- Image Placeholder Notice -->
            <div v-if="selectedFieldData && selectedFieldData.fieldName === 'Image'" class="mt-2">
              <div style="padding: 12px; background-color: #f0f7ff; border-left: 3px solid #2196f3; border-radius: 4px;">
                <small style="color: #1976d2;"><strong>{{ $t('barcode.designer.note') }}:</strong> {{ $t('barcode.designer.imageRuntimeNote') }}</small>
              </div>
            </div>

            <!-- Text fields size themselves to their content, so only Barcode and
                Image expose manual dimensions. -->
            <div class="mt-2" v-if="fn_isFixedSizeField(selectedFieldData)">
              <v-subheader class="pa-0 mb-2">{{ $t('barcode.designer.fieldDimensions') }}</v-subheader>
              <div style="display: flex; gap: 12px;">
                <v-text-field
                  v-model.number="selectedFieldData.width"
                  :label="$t('barcode.designer.widthMm')"
                  type="number"
                  step="0.5"
                  outlined
                  dense
                  @input="fn_updateFieldDimensions"
                ></v-text-field>
                <v-text-field
                  v-model.number="selectedFieldData.height"
                  :label="$t('barcode.designer.heightMm')"
                  type="number"
                  step="0.5"
                  outlined
                  dense
                  @input="fn_updateFieldDimensions"
                ></v-text-field>
              </div>
            </div>

            <div v-else class="mt-2">
              <small style="color: #999;">{{ $t('barcode.designer.sizeHint') }}</small>
            </div>

            <!-- Snap the field to an edge / centre of the label. -->
            <div class="mt-2">
              <v-subheader class="pa-0 mb-1">{{ $t('barcode.designer.alignment') }}</v-subheader>
              <div class="align-row">
                <span class="align-label">{{ $t('barcode.designer.horizontal') }}</span>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.hAlign === 'left' ? 'primary' : ''" @click="fn_alignField('h', 'left')">
                  <v-icon small :color="selectedFieldData.hAlign === 'left' ? 'primary' : ''">format_align_left</v-icon>
                </v-btn>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.hAlign === 'center' ? 'primary' : ''" @click="fn_alignField('h', 'center')">
                  <v-icon small :color="selectedFieldData.hAlign === 'center' ? 'primary' : ''" >format_align_center</v-icon>
                </v-btn>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.hAlign === 'right' ? 'primary' : ''" @click="fn_alignField('h', 'right')">
                  <v-icon small :color="selectedFieldData.hAlign === 'right' ? 'primary' : ''">format_align_right</v-icon>
                </v-btn>
              </div>
              <div class="align-row mt-2">
                <span class="align-label">{{ $t('barcode.designer.vertical') }}</span>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.vAlign === 'top' ? 'primary' : ''" @click="fn_alignField('v', 'top')">
                  <v-icon small :color="selectedFieldData.vAlign === 'top' ? 'primary' : ''">vertical_align_top</v-icon>
                </v-btn>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.vAlign === 'bottom' ? 'primary' : ''" @click="fn_alignField('v', 'bottom')">
                  <v-icon small :color="selectedFieldData.vAlign === 'bottom' ? 'primary' : ''">vertical_align_bottom</v-icon>
                </v-btn>
              </div>
              <div class="align-row mt-2">
                <span class="align-label">{{ $t('barcode.designer.orientation') }}</span>
                <v-btn small flat outline class="align-btn" :color="!selectedFieldData.rotation ? 'primary' : ''" @click="fn_setRotation(0)">
                  H (0°)
                </v-btn>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.rotation === 90 ? 'primary' : ''" @click="fn_setRotation(90)">
                  V (90°)
                </v-btn>
                <v-btn small flat outline class="align-btn" :color="selectedFieldData.rotation === 270 ? 'primary' : ''" @click="fn_setRotation(270)">
                  V (270°)
                </v-btn>
              </div>
            </div>

            <v-text-field
              v-if="selectedFieldData.fieldName !== 'Image'"
              v-model.number="selectedFieldData.fontSize"
              :label="$t('barcode.designer.fontSize')"
              type="number"
              outlined
              dense
              class="mt-5"
            ></v-text-field>

            <v-select
              v-if="selectedFieldData.fieldName !== 'Image'"
              v-model="selectedFieldData.fontFamily"
              :items="fontFamilies"
              :label="$t('barcode.designer.fontFamily')"
              outlined
              dense
              class="mt-3"
            ></v-select>

            <div v-if="selectedFieldData.fieldName !== 'Image'" class="mt-3">
              <v-layout row wrap>
                <v-flex xs4 sm4 md4>
                    <v-checkbox
                  v-model="selectedFieldData.fontBold"
                  :label="$t('barcode.designer.bold')"
                ></v-checkbox>
                </v-flex>

                <v-flex xs4 sm4 md4>
                  <v-checkbox
                    v-model="selectedFieldData.fontItalic"
                    :label="$t('barcode.designer.italic')"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs4 sm4 md4>
                  <v-checkbox
                    v-model="selectedFieldData.fontUnderline"
                    :label="$t('barcode.designer.underline')"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </div>

            <!-- <v-color-picker
              v-model="selectedFieldData.textColor"
              hide-inputs
              hide-sliders
              class="mt-3"
            ></v-color-picker> -->
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showFieldEditor = false">{{ $t('barcode.designer.cancel') }}</v-btn>
            <v-btn flat @click="fn_saveFieldEdits" color="primary">{{ $t('barcode.designer.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Preview Dialog -->
      <v-dialog
        v-model="showPreview"
        max-width="400px"
        transition="dialog-bottom-transition"
        v-if="showPreview"
      >
        <v-card>
          <v-card-title class="pl-3 pr-2 pt-1 pb-1">
            <span>{{ $t('barcode.designer.labelPreview') }}</span>
            <v-spacer></v-spacer>
            <v-btn icon class="pa-0 ma-0" @click="showPreview = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="preview-container">
            <div class="preview-info">
              <strong>{{ $t('barcode.designer.labelSizes') }}:</strong> {{ currentDimension.width }}mm × {{ currentDimension.height }}mm
            </div>
            <div
              class="preview-label"
              data-no-translate
              :style="{
                width: (currentDimension.width * previewScale) + 'px',
                height: (currentDimension.height * previewScale) + 'px',
                backgroundColor: '#fff',
                transform: 'scale(' + labelPreviewScale + ')'
              }"
            >
              <!-- Preview Fields -->
              <div
                v-for="(field, index) in fields"
                :key="'preview-' + index"
                class="preview-field"
                :style="getPreviewFieldStyle(field, index)"
              >
                <div class="field-content" v-if="field.fieldName === 'Barcode'">
                  <svg
                    :data-barcode-value="field.fieldValue || '123456789'"
                    style="height: 100%; width: auto; max-width: 100%; display: block;"
                  ></svg>
                </div>
                <div v-else-if="field.fieldName === 'Image' && field.imageData" class="field-content preview-image">
                  <img :src="field.imageData" style="width: 100%; height: 100%; object-fit: contain;">
                </div>
                <div v-else class="field-content preview-text">
                  <span>{{ fn_printText(field) }}</span>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-layout row wrap pb-2>
              <v-flex xs12 sm12 md12 pl-1 pr-1>
                <v-btn color="primary" block outline @click="fn_printSample"><v-icon color="primary" class="mr-2">print</v-icon> {{ $t('barcode.designer.printSample') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Image Upload Dialog -->
      <v-dialog
        v-model="showImageUpload"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-card-title class="pb-2">
            <span>{{ $t('barcode.designer.imagePlaceholder') }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="showImageUpload = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="image-upload-container">
              <p class="mb-3" style="color: #666;">
                {{ $t('barcode.designer.imagePlaceholderNote') }}
              </p>
              
              <div style="padding: 24px; background-color: #f5f5f5; border-radius: 4px; text-align: center;">
                <img 
                  :src="selectedFieldData && selectedFieldData.imageData ? selectedFieldData.imageData : 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22150%22 height=%22150%22%3E%3Crect width=%22150%22 height=%22150%22 fill=%22%23f5f5f5%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%220.3em%22 font-size=%2214%22 fill=%22%23999%22%3EImage%3C/text%3E%3C/svg%3E'"
                  style="max-width: 100%; max-height: 250px; border: 1px dashed #ddd; border-radius: 4px;"
                >
              </div>

              <p class="mt-3 mb-0" style="font-size: 12px; color: #999;">
                <strong>{{ $t('barcode.designer.tip') }}:</strong> Use the Edit button to adjust the image field dimensions (width and height) to match your layout needs.
              </p>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="showImageUpload = false" color="primary" block>
              Done
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Sheet Layout Dialog -->
      <v-dialog v-model="showSheet" scrollable fullscreen transition="dialog-bottom-transition">
        <v-card>
          <!-- <v-card-title class="pa-0 pl-2 pr-2">
            <span>{{ $t('barcode.designer.sheetLayout') }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="showSheet = false"><v-icon>close</v-icon></v-btn>
          </v-card-title> -->
          <!-- <v-alert type="info" :value="true">
            <div class="sheet-summary">
              {{ sheetCols }} × {{ sheetRows }} = <strong>{{ labelsPerPage }}</strong> per page
              · label {{ currentDimension.width }}×{{ currentDimension.height }}mm
              · {{ sheetTotal }} label(s) over {{ sheetPages.length }} page(s)
              <span v-if="sheetCapped" class="sheet-cap-note">— capped at {{ sheetMaxCells }} for preview</span>
            </div>
          </v-alert> -->

          <v-toolbar flat>
              <v-toolbar-side-icon @click="showSheet = false"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

              <v-toolbar-title class="white--text">{{ $t('barcode.designer.sheetLayout') }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon @click="fn_printSheet"><v-icon>print</v-icon></v-btn>
          </v-toolbar>

          <sheet-controls
            :sheet="sheet"
            :sheet-sizes="sheetSizes"
            :show-qty="true"
            :sheet-label-qty.sync="sheetLabelQty"
            :labels-per-page="labelsPerPage"
          ></sheet-controls>

          <v-divider></v-divider>

          <!-- the sheet(s) -->
        <v-card-text class="sheet-stage">
          <print-sheet :sheetPages="sheetPages" :sheetStyle="sheetStyle" :sheetCellStyle="sheetCellStyle" :sheetFieldStyle="sheetFieldStyle" :fields="fields" :printText="fn_printText"></print-sheet>
        </v-card-text>
        </v-card>
      </v-dialog>

      <!--
        Print raster source. Sized at exactly 1 CSS px per printer dot, so
        dom-to-image can capture it at scale 1 and get precisely
        printWidthDots × printHeightDots. Kept out of the visual flow rather than
        display:none, because dom-to-image cannot rasterize a hidden subtree.
      -->
      <div class="print-stage" aria-hidden="true">
        <!-- Offscreen text measurer for fn_autoSizeField. Inline-block + nowrap
            so it reports the natural width of the text at print resolution. -->
        <span
          ref="fieldMeasurer"
          style="position:absolute; visibility:hidden; white-space:nowrap; display:inline-block; padding:0; border:0; line-height:normal;"
        ></span>

        <div
          id="barcode-label-wrapper"
          :style="{
            width: printWidthDots + 'px',
            height: printHeightDots + 'px',
            position: 'relative',
            background: '#ffffff',
            overflow: 'hidden'
          }"
        >
          <!-- One positioned column per media column; fields inside keep their
               posLeft relative to their own column (getPrintFieldStyle). -->
          <div
            v-for="(colFields, c) in printColumns"
            :key="'print-col-' + c"
            :style="{
              position: 'absolute', top: '0px',
              left: (c * columnStepDots) + 'px',
              width: (currentDimension.width * printDotsPerMm) + 'px',
              height: printHeightDots + 'px',
              overflow: 'hidden'
            }"
          >
            <div
              v-for="(field, index) in colFields"
              :key="'print-' + c + '-' + index"
              :style="getPrintFieldStyle(field)"
            >
              <div v-if="field.fieldName === 'Barcode'" class="field-content">
                <svg :data-barcode-value="field.fieldValue || '123456789'" style="height: 100%; width: auto; max-width: 100%; display: block;"></svg>
              </div>
              <div v-else-if="field.fieldName === 'Image' && field.imageData" class="field-content">
                <img :src="field.imageData" style="width: 100%; height: 100%; object-fit: contain;">
              </div>
              <div v-else class="field-content">
                <span>{{ fn_printText(field) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-navigation-drawer  v-model="fieldDrawer" left absolute :width="280">
          <div>
            
            <div class="right-panel">
              <v-card flat class="fields-list-card">
                <v-card-title class="pb-2">
                    <v-icon left class="mr-2">list</v-icon> {{ $t('barcode.designer.fields') }}
                    <v-spacer></v-spacer>
                    <v-btn icon class="pa-0 ma-0" @click="fn_openFieldSelector"><v-icon>add</v-icon></v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="fields-list-content">
                    <div v-if="fields.length === 0" class="no-fields">
                        <p>{{ $t('barcode.designer.noFieldsAdded') }}</p>
                    </div>
                    <div
                    v-for="(field, index) in fields"
                    :key="'list-' + index"
                    class="field-item"
                    :class="{ 'field-item-selected': selectedFieldId === index }"
                    data-no-translate
                    >
                    <div class="field-item-content">
                        <strong>{{ field.fieldName }}</strong>
                        <small v-if="field.fieldValue" class="field-item-value">
                        {{ field.fieldValue }}
                        </small>
                    </div>
                    <!-- <v-btn
                        icon
                        small
                        @click.stop="fn_removeField(index)"
                    >
                        <v-icon small>close</v-icon>
                    </v-btn> -->

                    <v-menu bottom left>
                        <v-btn icon slot="activator">
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                        <v-list nopadding dense>
                            <v-list-tile @click="fn_selectField(index, true)">
                                <v-list-tile-title>{{ $t('barcode.designer.edit') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="fn_removeField(index)">
                                <v-list-tile-title>{{ $t('barcode.designer.remove') }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    
                    </div>

                    <v-btn block small color="red" style="width:fit-content;margin:auto;margin-top:16px" outline @click="fn_openDialogConfirmation" v-if="barcodeTemplateId && !isSystem">
                        <v-icon class="redcolor mr-2 font20">delete</v-icon> Delete Template
                    </v-btn>
                </v-card-text>
              </v-card>
          </div>

          </div>
      </v-navigation-drawer>
    </div>

    <!-- True-size print stage. Rendered at printPpm (real mm), not the preview
         scale, so the OS prints A4 as A4. Hidden on screen by App.vue's
         #printable{display:none}; shown only in @media print. -->
    <div id="printable" v-if="lazerPrintInitiated">
        <print-sheet
          :sheetPages="sheetPages"
          :sheetStyle="sheetStyle"
          :sheetCellStyle="sheetCellStyle"
          :sheetFieldStyle="sheetFieldStyle"
          :fields="fields"
          :printText="fn_printText"
          :ppm="printPpm"
          :forPrint="true"
        ></print-sheet>
    </div>

    <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" params="delete" :displayView='true' okBtnText="Yes" cancelBtnText="No"></dialog-confirmation>
  </div>
</template>

<script>
import PrintSheet from './components/print_sheet.vue';
import SheetControls from './components/sheet_controls.vue';
import barcodeMixin from './barcode_mixin';
import dialogConfirmation from '../dialogs/dialog_confirmation.vue';

export default {
  name: 'barcode_designer',
  mixins: [barcodeMixin],
  components: {
    'print-sheet': PrintSheet,
    'sheet-controls': SheetControls,
    'dialog-confirmation': dialogConfirmation
  },
  data() {
    return {
      // labelDimensions, currentDimension, fields, print/sheet geometry and both
      // print paths now live in barcode_mixin.js — shared with the generator.
      // labelName: 'dim3', // default to 48×30mm, the most common 58mm thermal label size
      // labelName: null,

      // Ruler and Canvas
      rulerUnit: 'mm',
      canvasBorder: 2, // must match the canvas border width in canvasStyle

      // Screen scale is derived from viewport width (see pxPerMm) so the label
      // fills the screen. It is a VIEW concern only — never let it leak into
      // stored geometry or print output, or designs stop being device-portable.
      viewportWidth: 0,
      rulerGutter: 40, // .ruler-y width; must match the CSS
      canvasMargin: 16, // breathing room either side of the canvas
      minPxPerMm: 3,
      maxPxPerMm: 14,

      // Field selection (the `fields` array itself comes from the mixin)
      selectedFieldId: null,
      selectedFieldData: null,

      // Dragging
      dragActive: null,
      dragOffset: { x: 0, y: 0 },
      holdTimer: null,
      dragMoveHandler: null,
      dragEndHandler: null,
      dragAnimFrame: null,
      dragStartTouchId: null,
      resizeHandler: null,

      // Label setup. Width and height are independent dropdowns; each holds a
      // number (a preset) or 'custom', and 'custom' enables that axis's input.
      widthSelection: 58,      // v-model of the width dropdown (a number, or 'custom')
      heightSelection: 30,     // v-model of the height dropdown (a number, or 'custom')
      printerType:'Label',

      // Dialogs (showPreview and the sheet state come from the mixin)
      showFieldSelector: false,
      showFieldEditor: false,
      showImageUpload: false,
      imageUploadFieldIndex: null,

      // Available Fields
      availableFields: [
        'Item Name',
        // 'Product Code',
        'Barcode',
        'Category',
        'Brand',
        'MRP',
        'Rate',
        'Unit',
        'Batch Number',
        'Mfg Date',
        'Exp Date',
        'Size',
        'Serial Number',
        'IMEI Number',
        'Part Number',
        'Model Number',
        'Text',
        // Prompt fields — value is asked for at generation, not bound to product.
        'Date',
        'Input Text',
        'Business Name'
        // 'Image'
      ],

      // Add-time prompt for Date / Input Text fields (label + unique check).
      showPromptDialog: false,
      promptDraft: { fieldName: '', inputType: '', label: '' },
      promptError: '',

      // Template storage. v2 stores geometry in mm; v1 stored screen px, which
      // is meaningless now the canvas scale follows the viewport. The old key
      // is dropped rather than migrated.
      templateKey: 'barcodeDesignTemplate_v2',
      legacyTemplateKey: 'barcodeDesignTemplate',
      templateVersion: 2,

      // Font Options
      fontFamilies: ['Arial', 'Helvetica', 'Times New Roman', 'Courier New', 'Georgia', 'Verdana'],
      isCustom:false,
      fieldDrawer:false,
      showFieldLabels:false,
      confirmationHeader:null,
      confirmationMessage:null,
      actionMethod:null,
      orderNumber:null,
      isSystem:0,
      hideConfigs:false,
      configPanel:false
    };
  },

  computed: {
    // Width picker: the predefined widths (the paper-size list) as numbers, plus
    // a trailing "Custom" that enables the width input.
    widthItems() {
      const items = (this.paperSizes || []).map(s => ({ text: s + ' mm', value: Number(s) }));
      items.push({ text: 'Custom', value: 'custom' });
      return items;
    },

    // Height picker: the paper's predefined heights (from the mixin's
    // paperHeights) plus a trailing "Custom…" that enables the height input.
    heightItems() {
      const items = (this.paperHeights || []).map(h => ({ text: h + ' mm', value: h }));
      items.push({ text: 'Custom', value: 'custom' });
      return items;
    },


    // Screen pixels per mm: fit the label to the available width. Width is
    // fixed at 48mm across every size, so fitting width (not both axes) keeps
    // the label the same physical size on screen whichever height is picked.
    pxPerMm() {
      const available = this.viewportWidth - this.rulerGutter - this.canvasMargin * 2 - this.canvasBorder * 2;
      const fitted = available / this.currentDimension.width;
      return Math.max(this.minPxPerMm, Math.min(this.maxPxPerMm, fitted));
    },

    canvasWidth() {
      return Math.round(this.currentDimension.width * this.pxPerMm);
    },

    canvasHeight() {
      return Math.round(this.currentDimension.height * this.pxPerMm);
    },

    selectedFieldLive() {
      if (this.selectedFieldId === null) return null;
      return this.fields[this.selectedFieldId] || null;
    },

    canvasStyle() {
      return {
        width: this.canvasWidth + 'px',
        height: this.canvasHeight + 'px',
        // content-box keeps the drawable area exactly canvasWidth × canvasHeight,
        // so field coordinates stay an exact multiple of pxPerMm.
        boxSizing: 'content-box',
        backgroundColor: '#ffffff',
        border: this.canvasBorder + 'px solid #333',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'default'
      };
    },

    // Rulers span the canvas border box, so they overshoot the drawable area
    // by the border on each side.
    rulerWidth() {
      return this.canvasWidth + this.canvasBorder * 2;
    },

    rulerHeight() {
      return this.canvasHeight + this.canvasBorder * 2;
    },

    xAxisMarks() {
      return this.generateAxisMarks('x');
    },

    yAxisMarks() {
      return this.generateAxisMarks('y');
    },

    // previewScale, print/sheet geometry computeds come from barcode_mixin.js.
  },

  watch: {
    // Opening the settings panel narrows the canvas column, so the fitted
    // scale has to be recomputed once the layout has settled.
    // (The sheet-barcode redraw watchers live in the mixin.)
    isCustom() {
      this.$nextTick(this.fn_measureViewport);
    }
  },

  methods: {
    // --- Label setup ------------------------------------------------------

    // Width dropdown: a preset (paper-size) width, or 'custom' which enables the
    // width input. A preset also drives the height list (paperHeights keys off
    // selectedPaperSize), so re-pick the height if it's no longer offered.
    fn_onWidthChange(val) {
      if (val === 'custom') return; // width input takes over; keep current width
      this.labelWidth = Number(val);
      this.selectedPaperSize = String(val);
      const heights = this.paperHeights || [];
      if (this.heightSelection !== 'custom' && heights.indexOf(this.labelHeight) === -1) {
        this.labelHeight = heights.length ? heights[0] : this.labelHeight;
        this.heightSelection = this.labelHeight;
      }
      this.fn_changeDimension();
    },

    // Height dropdown: a preset height, or 'custom' which enables the height input.
    fn_onHeightChange(val) {
      if (val === 'custom') return; // height input takes over; keep current height
      this.labelHeight = Number(val);
      this.fn_changeDimension();
    },

    // Custom inputs are bounded so a stray value can't break the canvas.
    fn_onCustomDim() {
      if (!(this.labelWidth > 0)) this.labelWidth = 5;
      if (!(this.labelHeight > 0)) this.labelHeight = 5;
      this.labelWidth = Math.max(5, Math.min(this.labelWidth, 200));
      this.labelHeight = Math.max(5, Math.min(this.labelHeight, 500));
      this.fn_changeDimension();
    },

    // On load / mount, reflect the current width & height in the two dropdowns:
    // a value that matches a preset selects it, otherwise the dropdown shows
    // 'custom' and that axis's input is enabled.
    fn_syncSetup() {
      const widthPresets = (this.paperSizes || []).map(Number);
      this.widthSelection = widthPresets.indexOf(Number(this.labelWidth)) !== -1
        ? Number(this.labelWidth) : 'custom';
      // Keep selectedPaperSize on a preset width so height presets stay populated.
      if (this.widthSelection !== 'custom') this.selectedPaperSize = String(this.labelWidth);
      const heights = this.paperHeights || [];
      this.heightSelection = heights.indexOf(Number(this.labelHeight)) !== -1
        ? Number(this.labelHeight) : 'custom';
    },

    fn_changeDimension(type) {
      // const dim = this.labelDimensions.find(d => d.labelName === this.labelName);
      // if (dim) {
        // this.currentDimension = { width: dim.width, height: dim.height };
        this.currentDimension = { width: this.labelWidth, height: this.labelHeight };
        // canvasWidth/canvasHeight are computed from pxPerMm — nothing to set.
        // Fields are stored in mm, so they keep their physical position; just
        // pull any that now fall outside a shorter label back inside.
        // Re-fit first (the cap depends on label size), then pull strays inside.
        this.$nextTick(() => {
          this.fn_autoSizeAll();
          this.fn_clampAllFields();

          // if(type == 'get_template'){
          //   let labelObj = this.labelDimensions.find(d => d.labelName === this.labelName);
          //   let barcodeTemplateId = 'template_' + this.labelName + '_' + labelObj.paperSize;
          //   this.fn_getTemplate(barcodeTemplateId);
          // }
        });
      // }
    },

    fn_clampAllFields() {
      this.fields.forEach((field, i) => {
        const maxLeft = Math.max(0, this.currentDimension.width - field.width);
        const maxTop = Math.max(0, this.currentDimension.height - field.height);
        if (field.posLeft > maxLeft) this.$set(this.fields[i], 'posLeft', this.fn_roundMm(maxLeft));
        if (field.posTop > maxTop) this.$set(this.fields[i], 'posTop', this.fn_roundMm(maxTop));
      });
    },

    // fn_roundMm lives in the mixin. These two are canvas-scale conversions,
    // so they stay here — pxPerMm is the designer's fit-to-screen scale.
    fn_mmToPx(mm) {
      return mm * this.pxPerMm;
    },

    fn_pxToMm(px) {
      return px / this.pxPerMm;
    },

    // Position for the selected field's name tag (design aid). Anchors at the
    // field's top-left; near the canvas top it anchors at the field's bottom
    // instead so the tag (which sits below in that case) clears the field.
    fn_badgeStyle(field) {
      const nearTop = this.fn_mmToPx(field.posTop) < 18;
      // A vertical field's on-canvas height is its stored width.
      const footprintH = field.rotation === 90 || field.rotation === 270 ? field.width : field.height;
      const topMm = nearTop ? (field.posTop + footprintH) : field.posTop;
      return {
        left: this.fn_mmToPx(field.posLeft) + 'px',
        top: this.fn_mmToPx(topMm) + 'px'
      };
    },

    generateAxisMarks(axis) {
      const marks = [];
      const lengthMm = axis === 'x' ? this.currentDimension.width : this.currentDimension.height;

      // Step in whole mm rather than accumulating a float pixel step, so the
      // last mark on a long ruler is as accurate as the first.
      // Only draw 1mm ticks when they'd be far enough apart to read.
      const tickMm = this.pxPerMm >= 4.5 ? 1 : 5;
      const midMm = 5;
      const labelMm = 10;

      for (let mm = 0; mm <= lengthMm; mm += tickMm) {
        const isLabel = mm % labelMm === 0;

        marks.push({
          // Offset by the canvas border so mark 0 sits on field coordinate 0,
          // not on the outer edge of the canvas frame.
          pos: mm * this.pxPerMm + this.canvasBorder,
          isLabel: isLabel,
          isMid: !isLabel && mm % midMm === 0,
          label: isLabel ? (this.rulerUnit === 'cm' ? (mm / 10).toString() : mm.toString()) : ''
        });
      }

      return marks;
    },

    // Measure the actual designer column rather than window.innerWidth, so the
    // settings panel (when open) doesn't push the canvas off screen.
    fn_measureViewport() {
      const panel = this.$el && this.$el.querySelector('.center-panel');
      const measured = panel ? panel.clientWidth : 0;
      this.viewportWidth = measured || window.innerWidth;
    },

    fn_openFieldSelector() {
        this.fieldDrawer = false;
        this.showFieldSelector = true;
    },

    fn_addField(fieldName) {
      // Date / Input Text are prompt fields: ask for a label first so multiple
      // of them stay distinguishable at generation. They're added once the
      // label dialog is confirmed.
      if (fieldName === 'Date' || fieldName === 'Input Text') {
        this.promptDraft = {
          fieldName: fieldName,
          inputType: fieldName === 'Date' ? 'date' : 'text',
          label: ''
        };
        this.promptError = '';
        this.showFieldSelector = false;
        this.showPromptDialog = true;
        return;
      }

      // Create a placeholder SVG image for Image fields
      const placeholderImage = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22100%22 height=%22100%22%3E%3Crect width=%22100%22 height=%22100%22 fill=%22%23f5f5f5%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%220.3em%22 font-size=%2212%22 fill=%22%23999%22%3EImage%3C/text%3E%3C/svg%3E';

      // All geometry below is in MILLIMETRES, not pixels — see fn_mmToPx.
      const isImage = fieldName === 'Image';
      const newField = {
        fieldName: fieldName,
        fieldValue: fieldName === 'Text' ? 'Sample Text' : (isImage ? '' : this.getFieldSampleValue(fieldName)),
        posLeft: 2,
        posTop: 2,
        // null = freely positioned (drag). Set to an edge only when the user
        // picks an alignment; see fn_alignField.
        hAlign: null,
        vAlign: null,
        rotation: 0, // 0 = horizontal, 90 = vertical
        width: isImage ? 15 : Math.min(30, this.currentDimension.width - 4),
        height: isImage ? 15 : 6,
        fontSize: 12, // points
        fontFamily: 'Arial',
        fontBold: false,
        fontItalic: false,
        textColor: '#000000',
        backgroundColor: 'transparent',
        borderColor: '#000000',
        // Per-field money label toggles (only read for MRP / Rate). Declared up
        // front so the editor checkbox v-model is reactive from the first click.
        mrpLabel: false,
        rateLabel: false,
        imageData: fieldName === 'Image' ? placeholderImage : null // Placeholder for Image fields
      };

      this.fn_pushField(newField);

      // If Image field, open placeholder dialog
      if (fieldName === 'Image') {
        this.imageUploadFieldIndex = this.selectedFieldId;
        this.showImageUpload = true;
      }

      if(fieldName === 'Text'){
        this.fn_editField();
      }
    },

    // Shared tail of adding any field: push, auto-size, select, mirror to the
    // editor copy.
    fn_pushField(newField) {
      this.fields.push(newField);
      this.$nextTick(() => this.fn_autoSizeField(this.fields.length - 1));
      this.showFieldSelector = false;
      this.selectedFieldId = this.fields.length - 1;
      this.selectedFieldData = JSON.parse(JSON.stringify(this.fields[this.selectedFieldId]));
    },

    // Confirm the add-time label dialog for a Date / Input Text field.
    fn_confirmPromptField() {
      const label = (this.promptDraft.label || '').trim();
      if (!label) { this.promptError = this.$t('barcode.designer.enterLabel'); return; }
      // Hard-block a duplicate label so generation prompts stay unambiguous.
      const clash = this.fields.some(f =>
        f.promptLabel && f.promptLabel.toLowerCase() === label.toLowerCase());
      if (clash) { this.promptError = this.$t('barcode.designer.labelExists'); return; }

      const isDate = this.promptDraft.inputType === 'date';
      const newField = {
        fieldName: this.promptDraft.fieldName, // 'Date' | 'Input Text'
        promptId: this.guidWeb(),              // stable identity for the value
        promptLabel: label,                    // differentiator + canvas hint
        inputType: this.promptDraft.inputType, // 'date' | 'text'
        dateFormat: isDate ? 'dd/MM/yyyy' : null,
        showCaption: false,                    // print caption, off by default
        captionText: label,                    // editable, usually shortened
        fieldValue: '',                        // filled at generation
        posLeft: 2, posTop: 2,
        hAlign: null, vAlign: null, rotation: 0,
        width: Math.min(30, this.currentDimension.width - 4), height: 6,
        fontSize: 12, fontFamily: 'Arial', fontBold: false, fontItalic: false,
        textColor: '#000000', backgroundColor: 'transparent', borderColor: '#000000',
        imageData: null
      };

      this.showPromptDialog = false;
      this.fn_pushField(newField);
    },

    fn_selectField(index, isEdit) {
      this.selectedFieldId = index;
      // this.selectedFieldData = { ...this.fields[index] };
      this.selectedFieldData = JSON.parse(JSON.stringify(this.fields[index])); // Deep copy to avoid reference issues
      // Older templates predate the money-label toggles; default them so the
      // editor checkbox has a reactive property to bind to.
      const d = this.selectedFieldData;
      if (d.mrpLabel === undefined) d.mrpLabel = false;
      if (d.rateLabel === undefined) d.rateLabel = false;
      isEdit ? this.fn_editField() : null;
    },

    fn_deselectField() {
      this.selectedFieldId = null;
      this.selectedFieldData = null;
    },

    fn_editField() {
      this.showFieldEditor = true;
      this.fieldDrawer = false;
    },

    // Dimensions are in mm and bounded by the label, not by the on-screen
    // canvas — a bound in screen px would change meaning with viewport width.
    fn_updateFieldDimensions() {
      const minMm = 2;
      const d = this.selectedFieldData;
      if (!d) return;

      if (!(d.width > 0)) d.width = minMm;
      if (!(d.height > 0)) d.height = minMm;

      d.width = Math.max(minMm, Math.min(d.width, this.currentDimension.width));
      d.height = Math.max(minMm, Math.min(d.height, this.currentDimension.height));

      // Resizing changes where an edge-aligned field should sit, so re-snap it.
      this.fn_applyAlignment(d);
    },

    // Snap the field to an edge (or centre) of the label. Left/Top mean the 0
    // edge; Right/Bottom subtract the field's own size; Center splits the slack.
    // Position is stored in mm, exactly like a dragged position, so nothing
    // downstream needs to know a field was aligned.
    fn_alignField(axis, value) {
      const d = this.selectedFieldData;
      if (!d) return;
      this.$set(d, axis === 'h' ? 'hAlign' : 'vAlign', value);
      this.fn_applyAlignment(d);
    },

    fn_applyAlignment(d) {
      if (!d) return;
      const labelW = this.currentDimension.width;
      const labelH = this.currentDimension.height;
      // A vertical field's on-label footprint is its width/height swapped.
      const rotated = d.rotation === 90 || d.rotation === 270;
      const w = (rotated ? d.height : d.width) > 0 ? (rotated ? d.height : d.width) : 0;
      const h = (rotated ? d.width : d.height) > 0 ? (rotated ? d.width : d.height) : 0;

      if (d.hAlign === 'left') this.$set(d, 'posLeft', 0);
      else if (d.hAlign === 'center') this.$set(d, 'posLeft', this.fn_roundMm(Math.max(0, (labelW - w) / 2)));
      else if (d.hAlign === 'right') this.$set(d, 'posLeft', this.fn_roundMm(Math.max(0, labelW - w)));

      if (d.vAlign === 'top') this.$set(d, 'posTop', 0);
      else if (d.vAlign === 'bottom') this.$set(d, 'posTop', this.fn_roundMm(Math.max(0, labelH - h)));
    },

    // 0 = horizontal, 90 = vertical. The mixin's fn_fieldGeometry rotates the
    // field about its top-left, so posLeft/posTop keep meaning the same corner.
    fn_setRotation(deg) {
      const d = this.selectedFieldData;
      if (!d) return;
      this.$set(d, 'rotation', deg);
    },

    fn_saveFieldEdits() {
      if (this.selectedFieldId !== null && this.selectedFieldData) {
        // this.fields[this.selectedFieldId] = { ...this.selectedFieldData };
        this.$set(
            this.fields,
            this.selectedFieldId,
            {
                ...this.selectedFieldData
            }
        );
        this.showFieldEditor = false;
        // Text or font may have changed, so re-fit the box to its content.
        const edited = this.selectedFieldId;
        this.$nextTick(() => this.fn_autoSizeField(edited));
      }
    },

    fn_removeField(index, closeDialog) {
      if (index === undefined) {
        index = this.selectedFieldId;
      }
      if (index !== null) {
        this.fields.splice(index, 1);
        this.selectedFieldId = null;
        this.selectedFieldData = null;
        // this.$forceUpdate();
      }

      closeDialog ? this.showFieldEditor = false : null;
    },

    fn_startDrag(e) {
      const isTouch = e.type.startsWith('touch');

      // Both @pointerdown and @touchstart are bound; where pointer events exist
      // they already cover touch, so ignore the duplicate touchstart.
      if (isTouch && window.PointerEvent) return;
      if (!isTouch && e.button !== 0) return; // Only left mouse button

      const clientX = isTouch ? e.touches[0].clientX : e.clientX;
      const clientY = isTouch ? e.touches[0].clientY : e.clientY;
      const fieldElement = e.currentTarget;
      const index = parseInt(fieldElement.id.replace('field-', ''), 10);
      const pointerId = isTouch ? null : e.pointerId;

      this.fn_selectField(index);

      // Attach the end listeners now, not inside the hold timer: a release
      // before the threshold must still be able to cancel the pending drag.
      this.fn_addDragListeners(isTouch);

      this.holdTimer = setTimeout(() => {
        this.holdTimer = null;
        this.dragActive = index;

        const rect = fieldElement.getBoundingClientRect();
        this.dragOffset.x = clientX - rect.left;
        this.dragOffset.y = clientY - rect.top;

        if (isTouch) {
          this.dragStartTouchId = e.touches[0].identifier;
        } else if (pointerId !== null) {
          try {
            fieldElement.setPointerCapture(pointerId);
          } catch (err) {
            console.warn('setPointerCapture failed:', err.message);
          }
        }

        fieldElement.classList.add('dragging');
      }, 150);
    },

    fn_attachDragListeners() {
      // Bind drag handlers to this context
      this.dragMoveHandler = this.fn_handleDragMove.bind(this);
      this.dragEndHandler = this.fn_handleDragEnd.bind(this);
    },

    fn_addDragListeners(isTouch) {
      if (isTouch) {
        document.addEventListener('touchmove', this.dragMoveHandler, { passive: false });
        document.addEventListener('touchend', this.dragEndHandler);
        document.addEventListener('touchcancel', this.dragEndHandler);
      } else {
        document.addEventListener('pointermove', this.dragMoveHandler);
        document.addEventListener('pointerup', this.dragEndHandler);
        document.addEventListener('pointercancel', this.dragEndHandler);
      }
    },

    fn_removeDragListeners() {
      // Remove both sets unconditionally — detaching a listener that was never
      // attached is a no-op, and it avoids leaking when the end event type
      // doesn't match the start event type.
      document.removeEventListener('touchmove', this.dragMoveHandler);
      document.removeEventListener('touchend', this.dragEndHandler);
      document.removeEventListener('touchcancel', this.dragEndHandler);
      document.removeEventListener('pointermove', this.dragMoveHandler);
      document.removeEventListener('pointerup', this.dragEndHandler);
      document.removeEventListener('pointercancel', this.dragEndHandler);
    },

    fn_handleDragMove(e) {
      if (this.dragActive === null) return;

      // Get coordinates for both touch and pointer events
      const isTouch = e.type.startsWith('touch');
      if (isTouch && e.cancelable) e.preventDefault(); // stop the page scrolling under the drag
      const clientX = isTouch ? e.touches[0].clientX : e.clientX;
      const clientY = isTouch ? e.touches[0].clientY : e.clientY;

      // Use requestAnimationFrame to throttle updates for smooth dragging
      if (this.dragAnimFrame) {
        cancelAnimationFrame(this.dragAnimFrame);
      }

      this.dragAnimFrame = requestAnimationFrame(() => {
        if (this.dragActive === null) return;

        const canvas = document.querySelector('.designer-canvas');
        if (!canvas) return;
        const canvasRect = canvas.getBoundingClientRect();

        // Work in px to follow the pointer, then commit in mm. Clamping happens
        // in mm against the label size so it can't drift with screen scale.
        const xPx = clientX - canvasRect.left - this.canvasBorder - this.dragOffset.x;
        const yPx = clientY - canvasRect.top - this.canvasBorder - this.dragOffset.y;

        const field = this.fields[this.dragActive];
        // A vertical field occupies a swapped footprint, so clamp against that.
        const fw = field.rotation === 90 || field.rotation === 270 ? field.height : field.width;
        const fh = field.rotation === 90 || field.rotation === 270 ? field.width : field.height;
        const maxXMm = this.currentDimension.width - fw;
        const maxYMm = this.currentDimension.height - fh;

        const xMm = Math.max(0, Math.min(this.fn_pxToMm(xPx), maxXMm));
        const yMm = Math.max(0, Math.min(this.fn_pxToMm(yPx), maxYMm));

        this.$set(this.fields[this.dragActive], 'posLeft', this.fn_roundMm(xMm));
        this.$set(this.fields[this.dragActive], 'posTop', this.fn_roundMm(yMm));

        // A manual move overrides any alignment, so drop it (the condition
        // makes this a one-time clear rather than every frame).
        if (field.hAlign || field.vAlign) {
          this.$set(this.fields[this.dragActive], 'hAlign', null);
          this.$set(this.fields[this.dragActive], 'vAlign', null);
        }

        this.fn_updateGuides(this.fn_mmToPx(xMm), this.fn_mmToPx(yMm));
      });
    },

    fn_handleDragEnd() {
      if (this.dragAnimFrame) {
        cancelAnimationFrame(this.dragAnimFrame);
        this.dragAnimFrame = null;
      }

      if (this.holdTimer) {
        clearTimeout(this.holdTimer);
        this.holdTimer = null;
      }

      if (this.dragActive !== null) {
        const fieldElement = document.getElementById('field-' + this.dragActive);
        if (fieldElement) {
          fieldElement.classList.remove('dragging');
        }
      }

      this.dragActive = null;
      this.dragStartTouchId = null;
      this.fn_removeDragListeners();
      this.fn_hideGuides();
    },

    fn_updateGuides(x, y) {
      const guideX = document.getElementById('guideX');
      const guideY = document.getElementById('guideY');

      if (guideX) {
        guideX.style.left = x + 'px';
        guideX.style.display = 'block';
      }
      if (guideY) {
        guideY.style.top = y + 'px';
        guideY.style.display = 'block';
      }
    },

    fn_hideGuides() {
      const guideX = document.getElementById('guideX');
      const guideY = document.getElementById('guideY');

      if (guideX) guideX.style.display = 'none';
      if (guideY) guideY.style.display = 'none';
    },

    hasCollision(fieldIndex) {
      if (this.fields.length < 2) return false;

      const field = this.fields[fieldIndex];
      const fieldRect = {
        left: field.posLeft,
        top: field.posTop,
        right: field.posLeft + field.width,
        bottom: field.posTop + field.height
      };

      for (let i = 0; i < this.fields.length; i++) {
        if (i === fieldIndex) continue;

        const otherField = this.fields[i];
        const otherRect = {
          left: otherField.posLeft,
          top: otherField.posTop,
          right: otherField.posLeft + otherField.width,
          bottom: otherField.posTop + otherField.height
        };

        // Check for overlap
        if (
          fieldRect.left < otherRect.right &&
          fieldRect.right > otherRect.left &&
          fieldRect.top < otherRect.bottom &&
          fieldRect.bottom > otherRect.top
        ) {
          return true;
        }
      }

      return false;
    },

    getFieldStyle(field, index) {
      return Object.assign(this.fn_fieldGeometry(field, this.pxPerMm), {
        border: '1px solid #ccc',
        backgroundColor: field.backgroundColor,
        borderColor: this.selectedFieldId === index ? '#2196F3' : '#ccc',
        cursor: 'move',
        borderRadius: '2px'
      });
    },

    // Size a text field to its content and commit the result as mm, so
    // field.width/height keep describing the real box. Measuring at print
    // resolution (not screen scale) keeps the result device-independent.
    // Barcode and Image are skipped — their size is a deliberate choice, not
    // a function of their content.
    fn_autoSizeField(index) {
      const field = this.fields[index];
      if (!field || this.fn_isFixedSizeField(field)) return;

      const el = this.$refs.fieldMeasurer;
      if (!el) return;

      const ppm = this.printDotsPerMm;
      el.style.fontSize = this.fn_ptToPx(field.fontSize, ppm) + 'px';
      el.style.fontFamily = field.fontFamily;
      el.style.fontWeight = field.fontBold ? 'bold' : 'normal';
      el.style.fontStyle = field.fontItalic ? 'italic' : 'normal';
      el.textContent = this.fn_canvasText(field) || ' ';

      // getBoundingClientRect keeps sub-pixel precision; offsetWidth would
      // round to whole dots and make narrow text creep wider on each edit.
      const rect = el.getBoundingClientRect();

      // The box is measured here at print resolution but rendered on the canvas
      // (and preview) at a different scale, on devices with a fractional pixel
      // ratio. Cross-scale rounding — plus 0.1mm size rounding below, and glyph
      // descenders (₹, g, y) that spill past the render's line-height:1 — can
      // leave the box a hair too small and clip the text, seemingly at random.
      // A small slack guarantees the box always fully contains its own content.
      // const SLACK_MM = 0.5;
      const widthMm = rect.width / ppm + this.fieldPadXMm * 2;
      const heightMm = rect.height / ppm + this.fieldPadYMm * 2;

      // Never let an auto-sized field exceed the label it lives on.
      const maxW = this.currentDimension.width - field.posLeft;
      const maxH = this.currentDimension.height - field.posTop;

      this.$set(this.fields[index], 'width', this.fn_roundMm(Math.min(widthMm, maxW)));
      this.$set(this.fields[index], 'height', this.fn_roundMm(Math.min(heightMm, maxH)));
    },

    fn_autoSizeAll() {
      this.fields.forEach((f, i) => this.fn_autoSizeField(i));
    },

    // fn_isFixedSizeField / fn_canvasText / fn_printText / fn_ptToPx /
    // fn_fieldGeometry / getPreviewFieldStyle / getPrintFieldStyle /
    // fn_drawBarcode all live in barcode_mixin.js now — shared with the generator.

    getFieldSampleValue(fieldName) {
      const samples = {
        'Item Name': 'Sample Item',
        // 'Product Code': 'ABC123',
        'Category': 'Electronics',
        'Brand': 'Brand Name',
        'Size': 'M',
        'Color': 'Red',
        'SKU': 'SKU12345',
        'MRP': '999',
        'Rate': '799',
        'Discount': '20%',
        // 'Expiry Date': '12/2025',
        'Batch No': 'B001',
        'Quantity': '10',
        'Unit': 'Pcs',
        'Manufacturer': 'Mfg Inc',
        'Business Name': this.$root.CurrentBusiness.BusinessName
      };
      return samples[fieldName] || fieldName;
    },



    fn_saveImageField() {
      // Close the image placeholder dialog
      this.showImageUpload = false;
      this.imageUploadFieldIndex = null;
    },

    // fn_saveTemplate() {
    //   const template = {
    //     version: this.templateVersion,
    //     units: 'mm', // geometry unit for every field; fontSize is in pt
    //     dimension: this.labelName,
    //     dimensionData: this.currentDimension,
    //     fields: this.fields
    //   };

    //   localStorage.setItem(this.templateKey, JSON.stringify(template));
    //   this.showToast(this.$t('barcode.designer.templateSaved'));
    //   this.fn_goBack();
    // },

    fn_saveTemplate: function() {

      if(!this.labelName || !this.labelWidth || !this.labelHeight) {
        this.showToast(this.$t('barcode.designer.provideNameDim'));
        return;
      }

      if(this.fields.length === 0) {
        this.showToast(this.$t('barcode.designer.addAtLeastOneField'));
        return;
      }

      if(!this.barcodeTemplateId){
        this.barcodeTemplateId = this.guid();
        this.orderNumber = Number(this.orderNumber) + 1;
      }

      // let labelObj = this.labelDimensions.find(d => d.labelName === this.labelName);

      let dataObj = {
        // barcodeTemplateId: 'template_' + this.labelName + '_' + labelObj.paperSize,
        barcodeTemplateId: this.barcodeTemplateId,
        // labelId: this.labelName + ' - ' + this.selectedPaperSize + 'mm - ' + this.labelWidth + 'x' + this.labelHeight,
        labelId: this.labelName + ' - ' + this.labelWidth + 'x' + this.labelHeight,
        labelName: this.labelName,
        labelWidth: this.labelWidth,
        labelHeight: this.labelHeight,
        unit:this.rulerUnit,
        // paperSize:this.selectedPaperSize,
        paperSize:this.widthSelection !== 'custom' ? this.selectedPaperSize : 'custom',
        orderNumber: this.orderNumber,
        printerType:this.printerType,
        fieldsData:{
          fields:JSON.stringify(this.fields),
          // Regular-printer sheet layout, saved with the template. Not the label
          // count (that's per-run). Normalised back out in fn_normalizeTemplate.
          sheet: JSON.stringify({
            paperSize:    this.sheet.paperSize,
            orientation:  this.sheet.orientation,
            marginTopMm:  this.sheet.marginTopMm,
            marginLeftMm: this.sheet.marginLeftMm,
            gapXMm:       this.sheet.gapXMm,
            gapYMm:       this.sheet.gapYMm
          }),
          // Thermal N-up media (columns + gaps), saved with the template so the
          // generator prints the same 2-up layout the design was built for.
          media: JSON.stringify({
            columns: this.media.columns,
            gapXMm:  this.media.gapXMm,
            gapYMm:  this.media.gapYMm
          })
        },
        isSystem:this.isSystem,
        additionalData:null
      }

      let self = this;
      this.postData('PostBarcodeTemplate', dataObj, 
				{
				onSuccess: function(response){
					console.log(response);
          let status = JSON.parse(response);
          if(status) {
            self.showToast(self.$t('barcode.designer.templateSaved'));
          }
          else {
            self.showToast(self.$t('barcode.designer.alreadyExistsName'));
          }
				}, 
				onError: function(error){
					console.log(error);
				}
			});
    },

    fn_getTemplate: function(templateId){
      let self = this;
      // let templateId = 'template_dim3_58mm';
      this.getData('GetBarcodeTemplate', templateId, 
				{
				onSuccess: function(response){
					console.log(response);
          // const raw = localStorage.getItem(this.templateKey);
          self.fields = [];
          if (response) {
            try {
              const savedTemplate = JSON.parse(response);
              if (savedTemplate) {
                self.barcodeTemplateId = self.$route.query.copy ? null : savedTemplate.barcodeTemplateId;
                self.labelName = savedTemplate.labelName;
                self.currentDimension = {
                  width: savedTemplate.labelWidth,
                  height: savedTemplate.labelHeight
                };
                self.selectedPaperSize = String(savedTemplate.paperSize);
                self.labelWidth = savedTemplate.labelWidth;
                self.labelHeight = savedTemplate.labelHeight;
                self.fields = savedTemplate.fieldsData ? JSON.parse(savedTemplate.fieldsData.fields) : '';
                if(!self.$route.query.copy){
                  self.orderNumber = savedTemplate.orderNumber ? savedTemplate.orderNumber : null;
                }
                self.printerType = savedTemplate.printerType;
                self.isSystem = savedTemplate.isSystem ? savedTemplate.isSystem : 0;
                self.additionalData = savedTemplate.additionalData ? JSON.parse(savedTemplate.additionalData) : null;
                savedTemplate.fieldsData && savedTemplate.fieldsData.sheet ? self.sheet = JSON.parse(savedTemplate.fieldsData.sheet) : '';
                // Thermal N-up media; older templates have none → keep 1-up default.
                if (savedTemplate.fieldsData && savedTemplate.fieldsData.media) {
                  try { self.media = JSON.parse(savedTemplate.fieldsData.media); } catch (e) { /* keep default */ }
                }
                self.fn_syncSetup(); // reflect the loaded width & height in the pickers
                self.fn_changeDimension()
              }
            } catch (err) {
              console.warn('discarding unreadable barcode template:', err.message);
              // localStorage.removeItem(this.templateKey);
            }
          }
				}, 
				onError: function(error){
					console.log(error);
				}
			});
    },

    fn_getTemplates: function () {
      let filterObject = {};

      let self = this;
      this.getItems("GetBarcodeTemplates", filterObject, 
        {
          onSuccess: function (response) {
            console.log(response);
          },
          onError: function (error) {
            console.log(error);
          }
        }
      )
    },

    fn_openDialogConfirmation: function(type){
      this.fieldDrawer = false;
      if(type === 'cancel'){
        this.confirmationHeader = 'Discard Changes';
        this.confirmationMessage = 'Are you sure you want to cancel? All unsaved changes will be lost.';
        this.actionMethod = this.fn_goBack;
      }
      else{
        this.confirmationHeader = 'Delete Template';
        this.confirmationMessage = 'Are you sure you want to delete this template? This action cannot be undone.';
        this.actionMethod = this.fn_deleteMaster;
      }
      this.$refs['ref_dialogConfirmation'].dialog_confimation = true;
    },

    fn_deleteMaster: function(){
				let self = this;
				this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
				this.fn_deleteMasterItem('deleteBarcodeTemplate', this.barcodeTemplateId, function(response){
					if(response){
              self.showToast(self.$t('barcode.designer.templateDeleted'));
              self.fn_goBack();
          }
          else{
              self.showToast(self.$t('barcode.designer.templateInUse'));
          }
				})
			},

      fn_deleteMasterItem: function(type, itemId, callback){
        let self = this;
        this.deleteData(type, itemId, {
            onSuccess: function(response){
                console.log(response);
                callback(JSON.parse(response));
            }, 
            onError: function(error){
              console.log(error);
            }
        });     
    },

    fn_labelPerview: function(){
      if(this.printerType == 'Label'){
        this.fn_openPreview();
      }
      else{
        this.fn_openSheet();
      }
    },

    fn_printSample: function(){
      if(this.$root.LabelPrintSettings && this.$root.LabelPrintSettings.printerConnectionType == 'usb'){
        this.fn_generateImage();
      }
      else{
        // this.fn_enableBluetooth();
        this.$root.fn_checkLocationPermission(()=>{
					this.fn_enableBluetooth();
				});
      }
    },

    fn_hideGaps: function(val){
      if(val == 1){
        this.media.gapXMm = 0;
        this.media.gapYMm = 0;
      }
    },

    fn_goBack() {
      this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
      this.$nextTick(()=>{
        this.$router.go(-1);
      })
    },

    fn_cancel: function(){
      // if(this.$refs['ref_dialogConfirmation'].dialog_confimation || ){
      //   this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
      // }
      if(this.showFieldSelector || this.showPromptDialog || this.showFieldEditor || this.showPreview || this.showImageUpload || this.showSheet || this.$refs['ref_dialogConfirmation'].dialog_confimation){
        this.showFieldSelector = false;
        this.showPromptDialog = false;
        this.showFieldEditor = false;
        this.showPreview = false;
        this.showImageUpload = false;
        this.showSheet = false;
        this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
      } 
      else{
        // this.fn_openDialogConfirmation('cancel');
        this.fn_goBack();
      }
    }

    // Preview, sheet rendering, sheet print and the whole thermal print chain
    // (fn_openPreview, fn_openSheet, sheetStyle/CellStyle/FieldStyle, fn_printSheet,
    // fn_printBarcode, fn_generateImage, fn_printReceipt, ...) live in barcode_mixin.js.

    // fn_printReceipt: function (dataUrl) {
    //   console.log('Printing receipt...');
    //   let dataObj = {
    //     "paperCut":true,
    //     "numberOfCopies":1,
    //     "printImageBase64":dataUrl ? dataUrl.substring(dataUrl.indexOf(',') + 1) : null,
    //     "printSize":384,
    //     "imageBinarization":1,
    //     "printDensity":12,
    //     "autoReply":false,
    //     "imageCommand":1
    //   }
    //   this.postData('PrintReceiptImage', dataObj, 
    //     { 
    //       onSuccess: function(response){
    //         console.log(response);
    //       }, 
    //       onError: function(error){
    //         console.log(error);
    //       }
    //     });
    // },
  },

  mounted() {
    window.js_globals.fn_onBackPress = this.fn_cancel;

    this.fn_measureViewport();
    this.resizeHandler = this.fn_measureViewport.bind(this);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('orientationchange', this.resizeHandler);

    // Drop any v1 (px-based) template; its coordinates have no meaning under
    // the viewport-derived scale.
    // localStorage.removeItem(this.legacyTemplateKey);

    // const raw = localStorage.getItem(this.templateKey);
    // if (raw) {
    //   try {
    //     const savedTemplate = JSON.parse(raw);
    //     if (savedTemplate && savedTemplate.version === this.templateVersion) {
    //       this.labelName = savedTemplate.dimension || this.labelName;
    //       this.fields = savedTemplate.fields || [];
    //     }
    //   } catch (err) {
    //     console.warn('discarding unreadable barcode template:', err.message);
    //     localStorage.removeItem(this.templateKey);
    //   }
    // }

    // Always derive currentDimension from the id so a saved dimensionData can't
    // disagree with labelDimensions after the list is edited.
    // this.fn_changeDimension();
    this.fn_attachDragListeners();

    if(this.$route.query.order_number){
      this.orderNumber = Number(this.$route.query.order_number);
    }

    if(this.$route.query.templateId){
      this.fn_getTemplate(this.$route.query.templateId);
    }
    else{
      // Fresh design: reflect the default width/height in the dropdowns.
      this.fn_syncSetup();
      this.fn_changeDimension();
    }

    // setTimeout(() => {
    //   if(this.$route.query.templateId){
    //     this.fn_getTemplate(this.$route.query.templateId);
    //   }
    // }, 300);
  },

  beforeDestroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      window.removeEventListener('orientationchange', this.resizeHandler);
    }
    if (this.dragMoveHandler) {
      this.fn_removeDragListeners();
    }
    if (this.dragAnimFrame) {
      cancelAnimationFrame(this.dragAnimFrame);
    }
    clearTimeout(this.holdTimer);
  },

  beforeRouteLeave(to, from, next) {
    // if(this.showFieldSelector || this.showPromptDialog || this.showFieldEditor || this.showPreview || this.showImageUpload || this.showSheet){
    //   this.showFieldSelector = false;
    //   this.showPromptDialog = false;
    //   this.showFieldEditor = false;
    //   this.showPreview = false;
    //   this.showImageUpload = false;
    //   this.showSheet = false;
    //   next(false);
    // } 
    // else{
    //   const s = document.getElementById('sheet-print-page-size');
    //   if (s) s.remove();
    //   next();
    // }
    const s = document.getElementById('sheet-print-page-size');
    if (s) s.remove();
    next();
  }
};
</script>

<style scoped>
.barcode-designer {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.designer-toolbar {
  background: linear-gradient(to right, #1976d2, #1565c0) !important;
}

.designer-container {
  /* display: flex; */
  /* flex: 1; */
  /* overflow: hidden; */
  /* margin-top: 56px; */
  gap: 8px;
  /* padding: 8px; */
}

/* Left Panel */
.left-panel {
  width: 300px;
  overflow-y: auto;
  flex-shrink: 0;
}

.settings-card {
  height: 100%;
  border-radius: 4px;
}

.settings-section {
  padding: 12px 0;
}

.dimension-display {
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
  color: #1976d2;
}

/* .label-setup {
  padding-top: 8px;
  padding-bottom: 4px;
} */

.setup-summary {
  font-size: 12px;
  color: #789;
}

.field-props {
  padding: 8px;
  background-color: #f9f9f9;
  border-left: 3px solid #1976d2;
  border-radius: 2px;
  font-size: 12px;
}

.field-props p {
  margin: 4px 0;
}

/* Field alignment controls */
.align-row {
  display: flex;
  align-items: center;
}

.align-label {
  width: 78px;
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}

.align-row .align-btn {
  min-width: 40px;
  margin: 2px 4px 2px 0;
}

/* Center Panel */
.center-panel {
  /* flex: 1; */
  min-width: 0; /* let it shrink inside the flex row so measurement is honest */
  display: flex;
  justify-content: center;
  overflow: auto;
}

.canvas-wrapper {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  background-color: white;
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Print raster source: positioned off screen rather than display:none, since
   dom-to-image cannot rasterize a subtree that isn't laid out. */
.print-stage {
  position: fixed;
  left: -10000px;
  top: 0;
  width: 0;
  height: 0;
  overflow: visible;
  pointer-events: none;
  z-index: -1;
}

.ruler-container {
  display: flex;
  align-items: flex-start;
}

/* The corner and the y-ruler are the left gutter of two separate rows; they
   must occupy identical width or the x-ruler drifts from the canvas. Both are
   border-box, and neither carries a left border, so the x-ruler's coordinate
   origin lines up with the canvas frame. */
.ruler-corner {
  width: 40px;
  height: 30px;
  box-sizing: border-box;
  background-color: #e0e0e0;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}

.ruler {
  background-color: #e0e0e0;
  position: relative;
  user-select: none;
}

.ruler-x {
  height: 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #999;
}

.ruler-y {
  width: 40px;
  box-sizing: border-box;
  border-right: 1px solid #999;
}

.ruler-mark {
  position: absolute;
}

.ruler-tick {
  position: absolute;
  background-color: #999;
}

.ruler-label {
  position: absolute;
  font-size: 9px;
  color: #333;
  white-space: nowrap;
  font-weight: bold;
  line-height: 1;
}

/* X ruler: ticks hang up from the canvas edge, labels sit above them. */
.ruler-x .ruler-mark {
  top: 0;
  height: 100%;
}

.ruler-x .ruler-tick {
  bottom: 0;
  width: 1px;
  height: 5px;
}

.ruler-x .ruler-tick-mid {
  height: 7px;
}

.ruler-x .ruler-tick-major {
  height: 11px;
}

.ruler-x .ruler-label {
  top: 4px;
  left: 0;
  transform: translateX(-50%);
}

/* Y ruler: mirror of the above. */
.ruler-y .ruler-mark {
  left: 0;
  width: 100%;
}

.ruler-y .ruler-tick {
  right: 0;
  height: 1px;
  width: 5px;
}

.ruler-y .ruler-tick-mid {
  width: 7px;
}

.ruler-y .ruler-tick-major {
  width: 11px;
}

.ruler-y .ruler-label {
  left: 4px;
  top: 0;
  transform: translateY(-50%);
}

.designer-canvas {
  position: relative;
  background-color: #ffffff;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
}

.designer-field {
  cursor: grab;
  will-change: transform;
  touch-action: none; /* let pointermove reach us instead of scrolling the page */
}

.designer-field.dragging {
  will-change: transform;
  z-index: 1000;
}

.designer-field:active {
  cursor: grabbing;
  z-index: 1000;
}

.designer-field.field-selected {
  border-color: #2196f3 !important;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.5);
  z-index: 2;
}

.designer-field.field-collision {
  border-color: #f44336 !important;
  background-color: #ffebee !important;
  box-shadow: 0 0 8px rgba(244, 67, 54, 0.5);
}

.field-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: center;
  /* font-size: 11px; */
  overflow: hidden;
}

.guide {
  position: absolute;
  z-index: 50;
  display: none;
}

.guide-x {
  width: 1px;
  height: 100%;
  background-color: rgba(33, 150, 243, 0.5);
}

.guide-y {
  width: 100%;
  height: 1px;
  background-color: rgba(33, 150, 243, 0.5);
}

/* Right Panel */
.right-panel {
  width: 280px;
  overflow: hidden;
  flex-shrink: 0;
}

.fields-list-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
}

.fields-list-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.no-fields {
  padding: 32px 16px;
  text-align: center;
  color: #999;
}

.field-item {
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s;
}

.field-item:hover {
  background-color: #f5f5f5;
}

.field-item.field-item-selected {
  background-color: #e3f2fd;
  border-left: 3px solid #2196f3;
}

.field-item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.field-item-content strong {
  font-size: 13px;
}

.field-item-value {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
}

/* Design-only field name tag for the selected field. */
.field-badge{
    position: absolute;
    transform: translateY(calc(-100% - 3px)); /* float just above the field */
    font-size: 9px;
    line-height: 1;
    white-space: nowrap;
    padding: 2px 6px;
    border-radius: 8px;
    background: #2196F3;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .25);
    pointer-events: none; /* never steal a tap meant for the field */
    z-index: 3;         /* above fields (selected field is z-index 3) */
}

.field-badge-below{
    transform: translateY(3px); /* top-edge fields: sit just below instead */
}

/* Responsive Design */
@media (max-width: 1200px) {
  /* .left-panel,
  .right-panel {
    display: none;
  } */

  .designer-container {
    flex-direction: column;
  }

  .center-panel {
    width: 100%;
  }
}

/* Preview Dialog Styles */
.preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background-color: #fafafa;
  max-height: 500px;
  overflow-y: auto;
}

.preview-info {
  margin-bottom: 16px;
  padding: 8px 16px;
  background-color: #e3f2fd;
  border-radius: 4px;
  font-size: 13px;
  color: #1976d2;
}

.preview-label {
  position: relative;
  background-color: #ffffff;
  border: 1px solid #999;
  /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15); */
  border-radius: 2px;
  overflow: hidden;
  /* transform:scale(0.3); */
}

.preview-field {
  position: absolute;
  /* border: 1px solid #ddd; */
  background-color: #ffffff;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 8px;
}

.preview-field .field-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.preview-field .preview-text {
  /* font-size: 8px; */
  line-height: 1;
  text-overflow: ellipsis;
}

/* Image Field Styles */
.canvas-image {
  background-color: #f5f5f5 !important;
  padding: 0 !important;
}

.canvas-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.preview-image {
  background-color: #f5f5f5;
  padding: 0 !important;
}

.preview-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-upload-container {
  padding: 16px 0;
}

/* Sheet layout dialog */
/* .sheet-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px 4px;
} */

.sheet-ctrl {
  max-width: 120px;
}

.sheet-ctrl-wide {
  max-width: 150px;
}

.sheet-summary {
  padding: 4px 16px 12px;
  font-size: 13px;
  color: #555;
}

.sheet-cap-note {
  color: #e65100;
}

.sheet-stage {
  background: #e9e9e9;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 16px;
  padding: 16px;
  /* max-height: 70vh; */
  overflow: auto;
}

.sheet-page {
  flex: none;
  margin-bottom: 16px;
}

/* Print isolation: App.vue only hides #non-printable, and this designer's
   chrome isn't wrapped in that, so hide every root child except #printable.
   The dynamic @page (size + margin:0) is injected by fn_printSheet. */
@media print {
  .barcode-designer {
    display: block;
    height: auto;
    background: #fff;
  }
  .barcode-designer > *:not(#printable) {
    display: none !important;
  }
  #printable {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/barcode/barcode_designer.vue